class BonuscardPineingabe extends HTMLElement {
    connectedCallback() {
        this.initScannerListener();
    }

    initScannerListener() {
        document.addEventListener("successful-scan", (event) => this.handleBonuscardScanResult(event))
    }

    handleBonuscardScanResult(event) {
        const bonuscardInput = this.querySelector("#kartennummer");
        bonuscardInput.value = event.detail.scanResult;
    }

}

if (!customElements.get("bonuscard-pineingabe")) {
    customElements.define("bonuscard-pineingabe", BonuscardPineingabe);
}